import {
  acceptUnAcceptSolution,
  deletePost,
  deleteTopic,
  toggleBookmarkTopic,
  fetchTopicData,
  appendPostOfTopic,
  setRepliesData,
  appendReplyOfTopic,
  removeReply,
  updatePost,
  toggleLike,
} from "../../redux/features/topicsSlice";
import { setIndiLoading } from "../../redux/features/loadingSlice";
import { useDispatch, useSelector } from "react-redux";
import { reactions } from "../../helpers/constants";
import { useNavigate } from "react-router-dom";
import React, { useState, useMemo, useRef, useEffect } from "react";
import axios from "axios";
import { showCustomToast } from "../../utils/toastUtil";
import { getQuillModules, imageHandler } from "../../utils/quillUtil";
import moment from "moment";
import DOMPurify from "dompurify";
import "quill/dist/quill.snow.css";
import "quill-mention";

import { CustomReactQuill } from "../Editor/CustomReactQuill";
// import {
//   setCountLoading,
//   togglePostReaction,
// } from "../../redux/features/postsSlice";

//this component can either be topic and can also be a post...posts can have replies...
const PostDetailItem = ({
  topicId,
  post,
  topicDetails,
  isTopic,
  postNumber,
  answer,
  showReplyForm,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cleanHTML = DOMPurify.sanitize(answer?.cooked, {
    FORBID_TAGS: ["script"], // Disallow specific tags
    FORBID_ATTR: ["onclick", "onload", "onerror"], // Disallow specific attributes
  });
  const username =
    post?.topic_creator?.name.length === 0
      ? post?.topic_creator?.username
      : post?.topic_creator?.name;
  const image = post?.avatar_template;
  const poster_image =
    process.env.REACT_APP_API_URL + `${image?.replace("{size}", "100")}`;
  const replied_to_image = post?.reply_to_user?.avatar_template;
  const reply_to_user_image = `${
    process.env.REACT_APP_API_URL + replied_to_image?.replace("{size}", "100")
  }`;

  const humanFriendlyDate = moment(post.created_at || post.created_at)
    .locale("ar")
    .fromNow();
  // =======================
  // useLocation
  // =======================

  // =======================
  // Redux State Management
  // =======================
  const { topicHasAcceptedSolution, replies, topicPosts } = useSelector(
    (state) => state.topics
  );

  const { loading } = useSelector((state) => state.loading);

  // =======================
  // useStates
  // =======================
  const [formVisible, setFormVisible] = useState(false);
  const [showReplies, setShowReplies] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [loadingReplies, setLoadingReplies] = useState(false);
  const [replying, setLoading] = useState(false);
  const [replyToolTips, setRepliesToolTips] = useState([]);
  const [replyToPostNumber, setReplyToPostNumber] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const [errors, setErrors] = useState([]);
  const [modalMaximized, setModalMaximized] = useState(false);
  const [updatedTitle, setUpdatedTitle] = useState(topicDetails?.title);

  const quillRef = useRef(null);
  const menuRef = useRef(null);
  const modalRef = useRef(null);
  const previewRefs = [useRef(null), useRef(null), useRef(null)];
  useEffect(() => {
    const handleMentionClick = (event) => {
      const mentionElement = event.target.closest(".mention");
      if (mentionElement) {
        event.preventDefault();
        let name = mentionElement.innerText.trim();
        if (name.startsWith("@")) {
          name = name.substring(1);
        }
        navigate("/profile", { state: { username: name } });
      }
    };

    // Attach event listener to all preview divs
    previewRefs.forEach((ref) => {
      if (ref.current) {
        ref.current.addEventListener("click", handleMentionClick);
      }
    });

    // Cleanup event listeners
    return () => {
      previewRefs.forEach((ref) => {
        if (ref.current) {
          ref.current.removeEventListener("click", handleMentionClick);
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleMentionClick = (event) => {
    const mentionElement = event.target.closest(".mention");
    if (mentionElement) {
      event.preventDefault();
      let name = mentionElement.innerText.trim();
      if (name.startsWith("@")) {
        name = name.substring(1);
      }
      navigate("/profile", { state: { username: name } });
    }
  };
  const toggleEdit = (p, e) => {
    e.stopPropagation();
    if (!p) return; // Prevent errors if no post is provided

    if (!formVisible) {
      setUpdatedTitle(topicDetails?.title);
    }

    setTimeout(() => {
      if (quillRef.current) {
        const editor = quillRef.current.getEditor();

        if (p.cooked) {
          editor.clipboard.dangerouslyPasteHTML(0, p.raw); // Properly load HTML content
        } else {
          editor.setText(""); // Clear the editor if there's no content
        }
      }
    }, 100); // Ensure Quill is ready
    setFormVisible((prev) => !prev);
  };
  const handleClose = () => {
    setFormVisible(false);
  };
  const matchedPost = topicPosts.find((p) => p.id === post.id);

  // =======================
  // quill module
  // =======================
  const modules = useMemo(
    () => getQuillModules(quillRef, imageHandler),
    [quillRef]
  );
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !modalMaximized &&
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !event.target.closest(".custom-toast")
      ) {
        handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalMaximized]);
  // =======================
  // Admin Authentication
  // =======================
  const userObj = localStorage.getItem("salla_discourse_user");
  const user = JSON.parse(userObj);
  const avatarTemplate =
    user?.avatar_template.replace("{size}", "100") ?? "default-avatar.png";
  let isLoggedin = false;
  let isAdmin = false;
  if (user) {
    isLoggedin = true;
    if (user.admin) {
      isAdmin = true;
    }
  }
  // =======================
  // API Calls
  // =======================

  const fetchPostReplies = async (postId) => {
    try {
      setLoadingReplies(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/posts/${postId}/replies`
      );
      const res = response.data;
      dispatch(setRepliesData(res));
      setLoadingReplies(false);
    } catch (err) {
      setErrors(err);
    }
  };

  // =======================
  // Handlers
  // =======================
  // const Reaction = ({ reaction }) => {
  //   return (
  //     <button key={reaction.label} className="hover:bg-gray-100 rounded-full">
  //       <div className="flex items-center">
  //         <p className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-gray-200 text-sm rounded px-2 py-1 opacity-0 group-hover:opacity-100 transition-opacity">
  //           {reactionsMap[reaction.label]}
  //         </p>
  //         <span
  //           role="img"
  //           aria-label={reaction.label}
  //           className="cursor-pointer"
  //         >
  //           {reaction.emoji}
  //         </span>
  //       </div>
  //     </button>
  //   );
  // };

  const toggleTopicReaction = async (postId, reaction) => {
    if (!postId || !reaction) return;

    const count = post?.reaction_users_count || 0;
    const previousReactions = post?.reactions || [];
    const isAdding = !post?.current_user_reaction; // Determine action based on current state
    // Calculate new reaction count optimistically:
    const newCount = isAdding ? count + 1 : Math.max(count - 1, 0);

    try {
      // Optimistically update reactions and user's reaction state
      const newReactions = toggleReactionOptimistically(
        previousReactions,
        reaction,
        isAdding
      );
      dispatch(
        toggleLike({
          isTopic,
          postId,
          reactions: newReactions,
          current_user_reaction: isAdding, // Toggle user's reaction state
          reaction_users_count: newCount,
        })
      );

      // API Call
      const url = `${process.env.REACT_APP_API_URL}/discourse-reactions/posts/${postId}/custom-reactions/${reaction}/toggle.json`;
      const response = await axios.put(url, {});

      if (!response.data.errors) {
        // Update with actual API response; if the API returns an updated count, use it.
        const updatedReactions = response.data.reactions;
        const current_user_reaction = response.data.current_user_reaction; // Assume API returns this
        const updatedCount =
          response.data.reaction_users_count !== undefined
            ? response.data.reaction_users_count
            : newCount;
        dispatch(
          toggleLike({
            isTopic,
            postId,
            reactions: updatedReactions,
            current_user_reaction,
            reaction_users_count: updatedCount,
          })
        );
      } else {
        throw new Error("API Error");
      }
    } catch (err) {
      // Rollback to previous state on error
      dispatch(
        toggleLike({
          isTopic,
          postId,
          reactions: previousReactions,
          current_user_reaction: post?.current_user_reaction,
          reaction_users_count: count,
        })
      );
    }
  };

  const toggleReactionOptimistically = (reactions, reactionType, isAdding) => {
    const newReactions = [...reactions];
    const existingIndex = newReactions.findIndex(
      (r) => r.type === reactionType
    );

    if (isAdding) {
      if (existingIndex !== -1) {
        // Increment existing reaction count
        newReactions[existingIndex] = {
          ...newReactions[existingIndex],
          count: newReactions[existingIndex].count + 1,
        };
      } else {
        // Add new reaction with count 1
        newReactions.push({ type: reactionType, count: 1 });
      }
    } else {
      if (existingIndex !== -1) {
        const currentCount = newReactions[existingIndex].count;
        if (currentCount > 1) {
          // Decrement existing reaction count
          newReactions[existingIndex] = {
            ...newReactions[existingIndex],
            count: currentCount - 1,
          };
        } else {
          // Remove reaction if count would be 0
          newReactions.splice(existingIndex, 1);
        }
      }
    }

    return newReactions;
  };

  const handleReactionClick = async (postId, reaction) => {
    if (!isLoggedin) {
      // navigate("/login");
      window.location.href =
        process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
      return false;
    }
    await toggleTopicReaction(postId, reaction.label);
  };

  function handleJumpToPost() {
    const targetAnswer = document.querySelector("[data-post-number='1']");
    targetAnswer.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }
  // async function handleLikePost(postId) {
  //   if (!isLoggedin) {
  //     window.location.href =
  //       process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
  //     return;
  //   }

  //   if (postLoading) return; // Prevent duplicate requests for this post

  //   dispatch(setCountLoading({ postId, loading: true })); // Set loading for this post
  //   console.log(postId);
  //   // **Optimistic UI Update**
  //   const nextIsLiked = !isLiked;
  //   const nextLikeCount = nextIsLiked ? likeCount + 1 : likeCount - 1;
  //   setIsLiked(nextIsLiked);
  //   setLikeCount(nextLikeCount);

  //   try {
  //     await dispatch(togglePostReaction(postId, nextIsLiked));
  //   } catch (err) {
  //     console.error("Error toggling reaction:", err);

  //     // **Revert UI on failure**
  //     setIsLiked(!nextIsLiked);
  //     setLikeCount(nextIsLiked ? likeCount - 1 : likeCount + 1);
  //   } finally {
  //     dispatch(setCountLoading({ postId, loading: false })); // Reset loading
  //   }
  // }
  const handleToggleReplies = async (open) => {
    if (!showReplies) {
      await fetchPostReplies(post.id);
      replies?.forEach((reply) => {
        setRepliesToolTips((prev) => [...prev, false]);
      });
    }
    if (open) {
      setShowReplies(true);
    } else {
      setShowReplies((prev) => !prev);
    }
  };

  async function handleFormSubmit(e) {
    e.preventDefault();
    setLoading(true);

    const editor = quillRef.current.getEditor();
    let value = editor.root.innerHTML;
    if (!value.trim() || value === "<p><br></p>") {
      showCustomToast("تحتاج إلى تقديم المحتوى أولاً", "error");
      setLoading(false);
      return;
    }
    const userObj = localStorage.getItem("salla_discourse_user");
    const headers = {};

    if (userObj) {
      const user = JSON.parse(userObj);
      headers["Api-Username"] = user?.id;
      headers["Api-Key"] = user?.api_key;
    }
    const formData = new FormData();
    const { id, category_id } = topicDetails;
    formData.append("raw", value);
    formData.append("category", category_id);
    formData.append("topic_id", id);
    formData.append("nested_post", "true");

    let isReply = false;

    if (post?.post_number) {
      formData.append("reply_to_post_number", post?.post_number);
      isReply = true;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/posts`, {
        method: "POST",
        headers: headers,
        body: formData,
      });

      const data = await response.json();
      console.log(data);

      if (response.ok) {
        if (replyToPostNumber) {
          dispatch(fetchTopicData(post?.id, postNumber));
        } else {
          if (isReply) {
            dispatch(appendReplyOfTopic(data?.post));
          } else {
            dispatch(appendPostOfTopic(data?.post));
          }
        }

        editor.setText("");
        setErrors([]);
      } else {
        setErrors(data.errors || []);
        console.error("Failed to post:", response.statusText);
      }
    } catch (error) {
      let errors = [];
      if (error.response && error.response.status === 422) {
        const errData = await error.response.json();
        errors = errData.errors ? Object.values(errData.errors).flat() : [];
      }
      setErrors(errors);
      console.error("Error:", error);
    } finally {
      setReplyToPostNumber(null);
      setLoading(false);
    }
  }

  // handle edit
  async function handleSubmitEdit(e) {
    e.preventDefault();
    setLoading(true);

    const editor = quillRef.current.getEditor();
    let value = editor.root.innerHTML;

    if (!value.trim() || value === "<p><br></p>") {
      showCustomToast("تحتاج إلى تقديم المحتوى أولاً", "error");
      setLoading(false);
      return;
    }
    const { id, category_id } = topicDetails;

    if (isTopic) {
      dispatch(
        updatePost({
          id,
          title: updatedTitle,
          raw: value,
          isTopic: true,
        })
      );
    } else {
      const postId = matchedPost?.id;

      dispatch(updatePost({ postId, raw: value, isTopic: false }));
    }
    if (isTopic) {
      const formData = new FormData();
      formData.append("category", category_id);
      formData.append("title", updatedTitle);
      if (Array.isArray(topicDetails?.tags)) {
        formData.append("tags[]", topicDetails.tags.join(","));
      }

      try {
        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}/forum/t/${id}.json`,
          formData
        );
        const { data } = response;

        if (data.success) {
          if (replyToPostNumber) {
            dispatch(fetchTopicData(post?.id, postNumber));
          }

          setErrors([]);
        } else {
          setErrors(response?.errors);
          console.error("Failed to post:", response.statusText);
        }

        await setLoading(false);
        await setFormVisible(false);
      } catch (error) {
        setErrors(error.response?.data?.errors || []);
        console.error("Error:", error);
        setLoading(false);
      } finally {
        setReplyToPostNumber(null);
        setLoading(false);
      }
    }
    const formDataPost = new FormData();

    formDataPost.append("post[topic_id]", id);
    formDataPost.append("post[original_text]", post?.raw);
    formDataPost.append("post[raw]", value);

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/forum/posts/${post?.id}.json`,
        formDataPost
      );
      const { data } = response;

      if (data.success) {
        if (replyToPostNumber) {
          dispatch(fetchTopicData(post?.id, postNumber));
        }
        setErrors([]);
      } else {
        setErrors(response?.errors);
        console.error("Failed to post:", response.statusText);
      }

      await setLoading(false);
      await setFormVisible(false);
    } catch (error) {
      setErrors(error.response?.data?.errors || []);
      console.error("Error:", error);
      setLoading(false);
    } finally {
      setReplyToPostNumber(null);
      setLoading(false);
    }
  }

  const handleShowOptions = (close = true) => {
    if (close === false) {
      setShowOptions(false);
    } else {
      setShowOptions((prev) => !prev);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleShowOptions(false);
      }
    };

    if (showOptions) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOptions]);

  const handleBookmarkPost = async (id, entry) => {
    if (!isLoggedin) {
      // navigate("/login");
      window.location.href =
        process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
      return false;
    }
    dispatch(
      setIndiLoading({ actionType: "bookmark", postId: id, value: true })
    );

    await dispatch(toggleBookmarkTopic(entry, isTopic));

    dispatch(
      setIndiLoading({ actionType: "bookmark", postId: id, value: false })
    );
  };
  const handleSolution = async (post) => {
    if (!isLoggedin) {
      // navigate("/login");
      window.location.href =
        process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
      return false;
    }
    dispatch(
      setIndiLoading({ actionType: "solution", postId: post.id, value: true })
    );

    await dispatch(acceptUnAcceptSolution(post));

    dispatch(
      setIndiLoading({ actionType: "solution", postId: post.id, value: false })
    );
  };

  const handleCopy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setShowTooltip(true);
      // Hide the tooltip after 2 seconds
      setTimeout(() => setShowTooltip(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const handleReplyCopy = async (text, index) => {
    try {
      await navigator.clipboard.writeText(text);
      setRepliesToolTips((prev) => {
        const newToolTips = [...prev];
        newToolTips[index] = true;
        return newToolTips;
      });
      // Hide the tooltip after 2 seconds
      setTimeout(
        () =>
          setRepliesToolTips((prev) => {
            const newToolTips = [...prev];
            newToolTips[index] = false;
            return newToolTips;
          }),
        2000
      );
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  // function handleJumpToPost() {
  //   const targetAnswer = document.querySelector("[data-post-number='1']");
  //   targetAnswer.scrollIntoView({
  //     behavior: "smooth",
  //     block: "center",
  //   });
  // }

  // =======================
  // Helper functions
  // =======================
  function removeMetaDivs(content) {
    if (!content) return "";

    // Remove meta divs
    const segments = content.split(/(?=<div)/g);
    const filteredSegments = segments.filter((segment) => {
      return !/<div[^>]*class=['"]?meta['"]?[^>]*>/.test(segment);
    });
    let processedContent = filteredSegments.join("");

    // Sanitize and parse into DOM
    const sanitizedDom = DOMPurify.sanitize(processedContent, {
      RETURN_DOM: true,
      FORBID_TAGS: ["script"],
      FORBID_ATTR: ["onclick", "onload", "onerror"],
      ALLOWED_TAGS: [
        "iframe",
        "a",
        "p",
        "div",
        "span",
        "strong",
        "em",
        "ul",
        "li",
        "br",
        "img",
      ],
    });

    // Function to replace URLs in text nodes
    const replaceUrlsInTextNodes = (node) => {
      const walker = document.createTreeWalker(
        node,
        NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT
      );
      let currentNode;
      const nodes = [];
      while ((currentNode = walker.nextNode())) {
        if (currentNode.nodeType === Node.TEXT_NODE) {
          nodes.push(currentNode);
        }
      }

      nodes.forEach((textNode) => {
        const text = textNode.textContent;
        const parent = textNode.parentNode;
        if (parent.nodeName === "A") return; // Skip URLs inside existing links

        const urlRegex =
          /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=_|!:,.;]*[-A-Z0-9+&@#/%=|]|www\.[-A-Z0-9+&@#/%?=~|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;

        let hasYouTubeLink = false;
        const matches = [];

        // First check if there's a YouTube link
        text.replace(urlRegex, (match, url, offset) => {
          const normalizedUrl = url.startsWith("www.") ? `http://${url}` : url;
          if (isYouTubeLink(normalizedUrl)) {
            hasYouTubeLink = true;
            matches.push({ match, url: normalizedUrl, offset });
          }
          return match;
        });

        if (!hasYouTubeLink) {
          // Process normal URLs as before
          const fragment = document.createDocumentFragment();
          let lastIndex = 0;

          text.replace(urlRegex, (match, url, offset) => {
            if (offset > lastIndex) {
              fragment.appendChild(
                document.createTextNode(text.slice(lastIndex, offset))
              );
            }

            const normalizedUrl = url.startsWith("www.")
              ? `http://${url}`
              : url;
            const a = document.createElement("a");
            a.href = normalizedUrl;
            a.target = "_blank";
            a.rel = "noopener noreferrer";
            a.textContent = match;
            fragment.appendChild(a);

            lastIndex = offset + match.length;
            return match;
          });

          if (lastIndex < text.length) {
            fragment.appendChild(
              document.createTextNode(text.slice(lastIndex))
            );
          }

          parent.replaceChild(fragment, textNode);
        } else {
          // For YouTube links, replace the entire parent structure with just the iframe
          const grandParent = parent.parentNode;

          // Create the iframe
          const iframe = document.createElement("iframe");
          iframe.src = getYouTubeEmbedUrl(matches[0].url);
          iframe.width = "100%";
          iframe.height = "360";
          iframe.style.maxWidth = "720px";
          iframe.allow =
            "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
          iframe.allowFullscreen = true;

          // Replace the parent (p or span) with just the iframe
          if (grandParent) {
            if (grandParent.parentNode) {
              grandParent.parentNode.replaceChild(iframe, grandParent);
            } else {
              // If there's no grandparent (unlikely in your case), just replace the direct parent
              parent.parentNode.replaceChild(iframe, parent);
            }
          }
        }
      });
    };

    // Helper functions
    const isYouTubeLink = (url) => {
      return url.includes("youtube.com/watch?v=") || url.includes("youtu.be/");
    };

    const getYouTubeEmbedUrl = (url) => {
      let videoId = "";

      if (url.includes("youtube.com/watch?v=")) {
        const urlObj = new URL(url);
        videoId = urlObj.searchParams.get("v");
      } else if (url.includes("youtu.be/")) {
        const match = url.match(/youtu\.be\/([a-zA-Z0-9_-]+)/);
        videoId = match ? match[1] : "";
      }

      return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
    };

    replaceUrlsInTextNodes(sanitizedDom);

    // Serialize and re-sanitize
    const finalHtml = new XMLSerializer().serializeToString(sanitizedDom);
    return DOMPurify.sanitize(finalHtml, {
      FORBID_TAGS: ["script"],
      FORBID_ATTR: ["onclick", "onload", "onerror"],
      ALLOWED_TAGS: [
        "iframe",
        "a",
        "p",
        "div",
        "span",
        "strong",
        "em",
        "ul",
        "li",
        "br",
        "img",
      ],
    });
  }
  // =======================
  // Togglers
  // =======================
  const reactionsMap = {};
  post?.reactions?.forEach((reaction) => {
    reactionsMap[reaction.id] = reaction.count;
  });

  const handleDelete = async (id, event) => {
    event.stopPropagation();
    dispatch(
      setIndiLoading({ actionType: "deletePost", postId: id, value: true })
    );

    if (isTopic) {
      await dispatch(deleteTopic(topicId));
      navigate("/");
    } else {
      await dispatch(deletePost(id));
    }

    dispatch(
      setIndiLoading({ actionType: "deletePost", postId: id, value: undefined })
    );
  };

  return (
    <div
      className="border-gray-300 sm:p-[24px_24px_20px_30px] p-[24px_24px_20px_24px] w-full rounded-2xl mt-3 bg-white"
      style={{ boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.06)" }}
    >
      {/*       {console.log(post)} */}
      <div>
        {isTopic && (
          <>
            <span className="text-[24px] font-bold break-words">
              {topicDetails?.title}
            </span>
          </>
        )}
        {/* post content section */}
      </div>
      <div className={`flex items-start mb-4 ${isTopic ? "pt-5" : ""}`}>
        <div className="flex items-center flex-wrap gap-y-2 justify-between w-full">
          <div className="flex gap-3 items-center cursor-pointer">
            <img
              src={poster_image}
              onClick={() => {
                navigate("/profile", {
                  state: {
                    username: post.topic_creator?.username,
                    id: post.topic_creator?.id,
                  },
                });
              }}
              className="w-[44px] h-[44px] rounded-full"
              alt=""
            />
            <div className="flex justify-between mt-0">
              <div>
                <div className="-mb-1.5">
                  <span className="text-[#444444] text-[16px] font-medium">
                    {username}
                  </span>
                </div>
                {replied_to_image && (
                  <div className="flex sm:hidden gap-3 ml-8">
                    <img src="/images/post/arrow-turn-back.svg" alt="" />
                    <img
                      src={reply_to_user_image}
                      className="w-[24px] h-[24px] rounded-full"
                      alt=""
                    />
                    <p className="text-[#666666] font-bold">
                      {post?.reply_to_user?.name?.length === 0
                        ? post?.reply_to_user?.username
                        : post?.reply_to_user?.name}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          {post?.accepted_answer && (
            <div className="bg-[#EFFBF6] rounded-full mb-1 w-auto">
              <div className="flex gap-2 ps-3 pe-2">
                <span className="text-[#008C56] mt-[3px] text-nowrap">
                  أفضل جواب
                </span>
                <img src="/images/home/tick.svg" alt="" />
              </div>
            </div>
          )}
        </div>
        {replied_to_image && (
          <div className="hidden sm:flex gap-3 ml-8">
            <img src="/images/post/arrow-turn-back.svg" alt="" />
            <img
              src={reply_to_user_image}
              className="w-[24px] h-[24px] rounded-full"
              alt=""
            />
            <p className="text-[#666666] font-bold">
              {post?.reply_to_user?.name?.length === 0
                ? post?.reply_to_user?.username
                : post?.reply_to_user?.name}
            </p>
          </div>
        )}
      </div>
      <div
        ref={previewRefs[0]}
        className="content text-right text-[#707070] mt-3 break-words"
        dangerouslySetInnerHTML={{
          __html: `<bdi>${removeMetaDivs(
            isTopic ? post?.raw : matchedPost?.raw
          )}</bdi>`,
        }}
      />

      {topicDetails?.tags?.length !== 0 && isTopic && (
        <div className="flex gap-2 flex-wrap mt-10">
          {topicDetails?.tags?.map((tag, index) => (
            <p
              key={index}
              className="h-auto text-[14px] text-[#444444]  bg-[#EEEEEE] px-2 w-fit rounded-full"
            >
              {tag}
            </p>
          ))}
        </div>
      )}

      {topicDetails?.accepted_answer && answer && (
        <div className="flex flex-col border-s-[10px] mt-5 border-[#76E8CD] bg-[#EEFCF9] sm:p-[20px_30px_40px_40px] p-[20px_20px_40px_40px]">
          <div className="flex flex-wrap gap-2">
            <img src="/images/home/tick.svg" alt="tick" />
            <p className="text-[#333333] text-base font-medium">
              مُجاب عليه من قبل
            </p>
            <p className="text-[#008c56] text-base font-medium">
              {answer?.display_username}
            </p>
            <p className="text-[#333333] text-base font-medium">في</p>
            <p
              onClick={handleJumpToPost}
              className="text-[#008c56] text-base font-medium cursor-pointer hover:underline"
            >
              #منشور {answer?.post_number}
            </p>
          </div>
          <div
            ref={previewRefs[1]}
            className="!text-[#707070] mt-3 break-words"
            dangerouslySetInnerHTML={{ __html: cleanHTML }}
          ></div>
        </div>
      )}

      {/* desktop view */}
      <div className={`flex gap-5 w-full items-center justify-between mt-5`}>
        <div className="flex gap-2 items-center max-lg:flex-wrap">
          <>
            {isTopic ? (
              <></>
            ) : (
              <div
                className={`${
                  showReplies ? "bg-[#EEFCF9]" : "hover:bg-gray-100"
                } cursor-pointer relative gap-2 flex justify-center items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] transition-colors px-3`}
                onClick={() => handleToggleReplies()}
              >
                <div
                  className={`${
                    showReplies ? "text-[#004D5A]" : "text-[#666666]"
                  } flex gap-1 text-sm font-medium items-center`}
                >
                  <span className="max-sm:hidden">التعليقات</span>
                  <img
                    className="sm:hidden block"
                    width={18}
                    src="/images/home/comment.svg"
                    alt="comment"
                  />
                  <span>({post?.reply_count})</span>
                  {loadingReplies ? (
                    <img
                      loading="eager"
                      src="/images/salla_loader_big.svg"
                      alt="Loading..."
                      className="w-4 h-4 loader"
                    />
                  ) : (
                    <img
                      src={
                        showReplies
                          ? "/images/arrow-down-01.png"
                          : "/images/arrow-down.png"
                      }
                      alt="chev"
                      className={`block ${showReplies ? "rotate-180" : ""}`}
                    />
                  )}
                </div>
              </div>
            )}
          </>

          {/* likes */}
          <div
            onClick={() =>
              post?.yours ? null : handleReactionClick(post?.id, reactions[0])
            }
            className="relative inline-block group"
          >
            {/* Icon that triggers the reactions bar */}
            <div
              className={`${
                post?.yours && isLoggedin
                  ? "cursor-not-allowed"
                  : "cursor-pointer"
              } flex gap-2 justify-center items-center border-[1px] px-3 h-[42px] hover:bg-gray-100 transition-colors border-[#EEEEEE] rounded-sm`}
            >
              {loading.react[post.id] ? (
                <img
                  loading="eager"
                  src="/images/salla_loader_big.svg"
                  alt="Loading..."
                  className="w-[12px] h-[15px] loader"
                />
              ) : (
                <>
                  {post?.current_user_reaction ? (
                    <img
                      src="/images/liked.svg"
                      title={
                        post?.yours
                          ? isLoggedin
                            ? "لا يمكنك الإعجاب بمنشورك الخاص"
                            : "سجل الدخول لتتمكن من الاعجاب"
                          : ""
                      }
                      onClick={
                        !isLoggedin
                          ? () =>
                              (window.location.href =
                                process.env.REACT_APP_API_URL +
                                `/auth/oauth2_basic`)
                          : () => null
                      }
                      alt="Heart"
                    />
                  ) : (
                    <img
                      src="/images/post/post-react.svg"
                      title={
                        post?.yours
                          ? isLoggedin
                            ? "لا يمكنك الإعجاب بمنشورك الخاص"
                            : "سجل الدخول لتتمكن من الاعجاب"
                          : ""
                      }
                      onClick={
                        !isLoggedin
                          ? () =>
                              (window.location.href =
                                process.env.REACT_APP_API_URL +
                                `/auth/oauth2_basic`)
                          : () => null
                      }
                      alt="Heart"
                    />
                  )}
                  {post?.reaction_users_count !== 0 && (
                    <span
                      className={`${
                        post?.current_user_reaction
                          ? "text-[#f55157]"
                          : "text-[#666666]"
                      } text-sm font-normal`}
                    >
                      {post?.reaction_users_count}
                    </span>
                  )}
                </>
              )}
            </div>
          </div>

          {/* reply */}
          {!isTopic && (
            <div
              className="gap-2 hidden sm:flex justify-center items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] hover:bg-gray-100 transition-colors cursor-pointer ps-3 pe-[19px]"
              onClick={async () => {
                if (!isLoggedin) {
                  // navigate('/login');
                  window.location.href =
                    process.env.REACT_APP_API_URL + `/auth/oauth2_basic`;
                } else {
                  await handleToggleReplies(true);
                  setTimeout(
                    () =>
                      quillRef.current.getEditor().root.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                      }),
                    0
                  );
                }
              }}
            >
              <img
                src="/images/post/post-reply.svg"
                title={isLoggedin ? "" : "تسجيل الدخول للرد"}
                alt=""
              />
              <p className="text-[#666666] text-sm font-medium">رد</p>
            </div>
          )}

          <div className="relative flex max-1060:-mx-1 min-1060:gap-x-2">
            <div
              style={
                isTopic
                  ? {}
                  : showOptions
                  ? {
                      display: "flex",
                      flexDirection: "column",
                      position: "absolute",
                      overflow: "clip",
                    }
                  : { display: "none" }
              }
              className={`min-1060:!flex min-1060:!static min-1060:!flex-row ${
                isTopic
                  ? "flex"
                  : "hidden max-1060:bg-white no-bottom-shadow max-1060:w-[115px]"
              } sm:top-[98px] start-5 top-[140px] z-10 gap-x-2`}
            >
              {/* bookmarks */}
              <div
                className={`relative gap-2 flex items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] hover:bg-gray-100 transition-colors ps-3 ${
                  isTopic ? "max-820px:pe-5 pe-3" : "pe-3"
                } ${isLoggedin ? "cursor-pointer" : "cursor-not-allowed"}`}
                onClick={() => handleBookmarkPost(post?.id, post)}
              >
                {loading.bookmark[post.id] ? (
                  <>
                    <img
                      loading="eager"
                      src="/images/salla_loader_big.svg"
                      alt="Loading..."
                      className="w-[12px] h-[15px] loader"
                    />
                    {isTopic && (
                      <p className="text-[#666666] text-sm font-medium max-820:hidden">
                        اقرأ لاحقًا
                      </p>
                    )}
                    <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                      اقرأ لاحقًا
                    </p>
                  </>
                ) : (
                  <>
                    {post?.bookmarked && isLoggedin ? (
                      <img
                        src="/images/post/save-filled.svg"
                        className="w-[12px] h-[15px]"
                        alt="Bookmarked"
                      />
                    ) : (
                      <img
                        src="/images/post/post-bookmark.svg"
                        title={"تسجيل الدخول إلى المرجعية"}
                        alt="Save"
                      />
                    )}
                    {isTopic && (
                      <p className="text-[#666666] text-sm font-medium max-820:hidden">
                        اقرأ لاحقًا
                      </p>
                    )}
                    {!isTopic && (
                      <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                        اقرأ لاحقًا
                      </p>
                    )}
                  </>
                )}
              </div>

              {/* paperclip */}
              <div
                className={`relative gap-2 flex items-center border-[1px] border-[#EEEEEE] min-1060:rounded-sm rounded-b-lg h-[42px] hover:bg-gray-100 transition-colors cursor-pointer ps-3 ${
                  isTopic ? "max-820px:pe-5 pe-3" : "pe-3"
                }`}
                onClick={() =>
                  handleCopy(
                    `${process.env.REACT_APP_URL}/detail/${topicId}/${post.post_number}`
                  )
                }
              >
                <img src="/images/post/post-copy.svg" alt="" />
                {isTopic && (
                  <p className="text-[#666666] text-sm font-medium max-820:hidden">
                    نسخ الرابط
                  </p>
                )}
                {!isTopic && (
                  <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                    نسخ الرابط
                  </p>
                )}
                {showTooltip && (
                  <div
                    className="absolute top-[-30px] left-[50%] transform -translate-x-1/2 bg-[#004D5A] text-white text-xs px-2 py-1 rounded-md shadow"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    تم نسخ الرابط
                  </div>
                )}
              </div>
            </div>

            <div
              ref={menuRef}
              style={
                showOptions
                  ? {
                      display: "flex",
                      flexDirection: "column",
                      position: "absolute",
                      overflow: "clip",
                    }
                  : { display: "none" }
              }
              className={`no-bottom-shadow min-1060:!flex min-1060:!static z-10 min-1060:!flex-row hidden max-1060:w-[115px] max-1060:bg-white ${
                isTopic ? "-top-20 start-28" : "top-4 start-5"
              } gap-x-2`}
            >
              {/* post time mobile */}
              {!isTopic && (
                <div className="relative gap-2 max-sm:flex hidden items-center border-[1px] border-[#EEEEEE] rounded-t-lg h-[42px] hover:bg-gray-100 transition-colors ps-3 pe-3  cursor-pointer">
                  <img
                    className=""
                    src="/images/post/post-date.svg"
                    alt="clock"
                  />
                  <p className="text-right text-[#999999] text-xs font-medium whitespace-nowrap">
                    {humanFriendlyDate}
                  </p>
                </div>
              )}

              {/* edit post */}
              {post?.yours && isLoggedin && (
                <div
                  onClick={(e) => toggleEdit(post, e)}
                  className={`relative gap-2 flex items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] hover:bg-gray-100 transition-colors ps-3 ${
                    isTopic ? "max-820px:pe-5 pe-3" : "pe-3"
                  }  ${isLoggedin ? "cursor-pointer" : "cursor-not-allowed"}`}
                >
                  {loading.edit[post.id] ? (
                    <>
                      {isTopic && (
                        <>
                          <img
                            loading="eager"
                            src="/images/salla_loader_big.svg"
                            alt="Loading..."
                            className="w-[12px] h-[15px] loader"
                          />
                          <p className="text-[#666666] text-sm font-medium">
                            تعديل
                          </p>
                        </>
                      )}
                      {!isTopic && (
                        <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                          تعديل
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      {isTopic && (
                        <>
                          <img src="/images/post/post-edit.svg" alt="edit" />
                          <p className="text-[#666666] text-sm font-medium">
                            تعديل
                          </p>
                        </>
                      )}
                      {!isTopic && (
                        <>
                          <img src="/images/post/post-edit.svg" alt="edit" />
                          <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                            تعديل
                          </p>
                        </>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* delete */}
              {post?.yours && isLoggedin && (
                <div
                  onClick={(e) => handleDelete(post?.id, e)}
                  className={`relative gap-2 flex items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] hover:bg-gray-100 transition-colors ps-3 ${
                    isTopic ? "max-820px:pe-5 pe-3" : "pe-3"
                  }  ${isLoggedin ? "cursor-pointer" : "cursor-not-allowed"}`}
                >
                  {loading.deletePost[post.id] ? (
                    <>
                      <img
                        loading="eager"
                        src="/images/salla_loader_big.svg"
                        alt="Loading..."
                        className="w-[12px] h-[15px] loader"
                      />
                      {isTopic && (
                        <p className="text-[#666666] text-sm font-medium">
                          حذف
                        </p>
                      )}
                      {!isTopic && (
                        <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                          حذف
                        </p>
                      )}
                    </>
                  ) : (
                    <>
                      <img src="/images/post/post-delete.svg" alt="delete" />
                      {isTopic && (
                        <p className="text-[#666666] text-sm font-medium">
                          حذف
                        </p>
                      )}
                      {!isTopic && (
                        <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                          حذف
                        </p>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>

          {post?.yours && (
            <div
              onClick={() => handleShowOptions()}
              className="min-1060:!hidden flex"
            >
              <img
                src="/images/post/show-more-options.svg"
                className="min-w-[42px]"
                alt="more"
              />
            </div>
          )}

          {/* mark as solved */}
          {isLoggedin &&
            (isAdmin || topicDetails?.mainPost?.yours) &&
            (loading.solution[post.id] ? (
              <img
                loading="eager"
                src="/images/salla_loader_big.svg"
                alt="Loading..."
                className="w-[12px] h-[15px] loader"
              />
            ) : (
              <>
                {post?.accepted_answer && (
                  <div
                    onClick={() => handleSolution(post)}
                    className="flex gap-2 justify-center items-center border-[1px] p-[9px] h-[42px] hover:bg-gray-100 cursor-pointer rounded-sm border-[#EEEEEE]"
                  >
                    <img
                      src="/images/post/post-solve.svg"
                      alt=""
                      className="w-4 h-4"
                    />
                    <p className="text-[#666666] text-sm font-medium text-nowrap">
                      الغاء الجواب
                    </p>
                  </div>
                )}
                {!isTopic && !topicHasAcceptedSolution && (
                  <div
                    onClick={() => handleSolution(post)}
                    className="flex justify-center gap-2 items-center border-[1px] p-[9px] h-[42px] cursor-pointer hover:bg-gray-100 rounded-sm border-[#EEEEEE]"
                  >
                    <img
                      src="/images/post/post-solve.svg"
                      alt=""
                      className="w-4 h-4"
                    />
                    <p className="text-[#666666] text-sm font-medium text-nowrap">
                      أفضل جواب
                    </p>
                  </div>
                )}
              </>
            ))}
        </div>

        {/* post analytics */}
        <div
          className={` ${
            !isTopic ? "sm:flex hidden" : "flex"
          }  gap-5 items-center`}
        >
          {isTopic && (
            <div className="flex justify-center items-center gap-2">
              <img src="/images/post/post-views.svg" alt="" />
              <span className="text-right text-[#999999] text-xs font-medium h-2.5">
                {post?.views}
              </span>
            </div>
          )}
          <div className="flex gap-2 items-center">
            <img
              className="block"
              src="/images/post/post-date.svg"
              alt="clock"
            />
            <p className="text-right text-[#999999] text-xs font-medium whitespace-nowrap">
              {humanFriendlyDate}
            </p>
          </div>
        </div>
      </div>

      {/* Replies */}
      {showReplies && (
        <div className="flex">
          <div className="flex flex-col w-full">
            {replies?.map((reply, index) => {
              const cleanHTML = DOMPurify.sanitize(reply?.cooked, {
                FORBID_TAGS: ["script"], // Disallow specific tags
              });
              const replier_image = `${reply?.avatar_template?.replace(
                "{size}",
                "100"
              )}`;
              return (
                <div className="flex w-full" key={index}>
                  <div className={`mt-5 border-s sm:ms-8 ms-3 -mb-5`}></div>
                  <div className="flex flex-col mt-5 mb-10 w-full" key={index}>
                    {/* div for name of person who did the reply */}
                    <div className="flex gap-2 items-center">
                      <hr className="sm:w-7 w-4" />
                      <div className="flex gap-3 items-center mb-2">
                        <img
                          src={replier_image}
                          className="w-[44px] h-[44px] rounded-full cursor-pointer"
                          onClick={() => {
                            navigate("/profile", {
                              state: {
                                username: reply.topic_creator?.username,
                                id: reply.topic_creator?.id,
                              },
                            });
                          }}
                          alt=""
                          onError={(e) => {
                            e.target.src =
                              `${process.env.REACT_APP_API_URL}` +
                              replier_image;
                          }}
                        />
                        <div className="flex-col">
                          <div>
                            <span className="text-[#444444] text-base font-medium">
                              {reply?.name.length === 0
                                ? reply?.username
                                : reply?.name}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* div for the displaying the post that he replied to */}
                    <div className="mb-4 sm:ms-[90px] ms-[44px]">
                      <div
                        onClick={(e) => handleMentionClick(e)}
                        className="content text-right text-[#707070] mb-4 break-words"
                        dangerouslySetInnerHTML={{
                          __html: `<bdi>${cleanHTML}</bdi>`,
                        }}
                      ></div>
                    </div>
                    <div className="flex justify-between items-center sm:ms-[90px] ms-[44px] gap-3">
                      <div className="flex gap-3 max-sm:flex-wrap">
                        {/* like */}
                        <div
                          onClick={() =>
                            reply?.yours
                              ? null
                              : handleReactionClick(reply?.id, reactions[0])
                          }
                          className="relative inline-block group"
                        >
                          {/* Icon that triggers the reactions bar */}
                          <div
                            className={`${
                              reply?.yours && isLoggedin
                                ? "cursor-not-allowed"
                                : "cursor-pointer"
                            } flex gap-2 justify-center items-center border-[1px] px-3 h-[42px] hover:bg-gray-100 transition-colors border-[#EEEEEE] rounded-sm`}
                          >
                            {loading.react[reply.id] ? (
                              <img
                                loading="eager"
                                src="/images/salla_loader_big.svg"
                                alt="Loading..."
                                className="w-[12px] h-[15px] loader"
                              />
                            ) : (
                              <>
                                {reply?.current_user_reaction ? (
                                  <img
                                    src="/images/liked.svg"
                                    title={
                                      reply?.yours
                                        ? isLoggedin
                                          ? "لا يمكنك الإعجاب بمنشورك الخاص"
                                          : "سجل الدخول لتتمكن من الاعجاب"
                                        : ""
                                    }
                                    onClick={
                                      !isLoggedin
                                        ? () =>
                                            (window.location.href =
                                              process.env.REACT_APP_API_URL +
                                              `/auth/oauth2_basic`)
                                        : null
                                    }
                                    alt="Heart"
                                  />
                                ) : (
                                  <img
                                    src="/images/post/post-react.svg"
                                    title={
                                      reply?.yours
                                        ? isLoggedin
                                          ? "لا يمكنك الإعجاب بمنشورك الخاص"
                                          : "سجل الدخول لتتمكن من الاعجاب"
                                        : ""
                                    }
                                    onClick={
                                      !isLoggedin
                                        ? () =>
                                            (window.location.href =
                                              process.env.REACT_APP_API_URL +
                                              `/auth/oauth2_basic`)
                                        : () => null
                                    }
                                    alt="Heart"
                                  />
                                )}

                                {reply?.reaction_users_count !== 0 && (
                                  <span
                                    className={`${
                                      reply?.current_user_reaction
                                        ? "text-[#f55157]"
                                        : "text-[#666666]"
                                    } text-sm font-normal`}
                                  >
                                    {reply?.reaction_users_count}
                                  </span>
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {/* bookmark reply */}
                        <div
                          className={`relative gap-2 flex justify-center items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] hover:bg-gray-100 transition-colors ps-3 ${
                            isTopic ? "max-820px:pe-5 pe-3" : "pe-3"
                          } ${
                            isLoggedin ? "cursor-pointer" : "cursor-not-allowed"
                          }`}
                          onClick={() => handleBookmarkPost(reply?.id, reply)}
                        >
                          {loading.bookmark[reply.id] ? (
                            <>
                              <img
                                loading="eager"
                                src="/images/salla_loader_big.svg"
                                alt="Loading..."
                                className="w-[12px] h-[15px] loader"
                              />
                              {isTopic && (
                                <p className="text-[#666666] text-sm font-medium max-820:hidden">
                                  اقرأ لاحقًا
                                </p>
                              )}
                            </>
                          ) : (
                            <>
                              {reply?.bookmarked && isLoggedin ? (
                                <img
                                  src="/images/post/save-filled.svg"
                                  className="w-[12px] h-[15px]"
                                  alt="Bookmarked"
                                />
                              ) : (
                                <img
                                  src="/images/post/post-bookmark.svg"
                                  title={"تسجيل الدخول إلى المرجعية"}
                                  alt="Save"
                                />
                              )}
                              {isTopic && (
                                <p className="text-[#666666] text-sm font-medium max-820:hidden">
                                  اقرأ لاحقًا
                                </p>
                              )}
                            </>
                          )}
                        </div>

                        {/* paperclip */}
                        <div
                          className={`relative gap-2 flex justify-center items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] hover:bg-gray-100 transition-colors cursor-pointer ps-3 ${
                            isTopic ? "max-820px:pe-5 pe-3" : "pe-3"
                          }`}
                          onClick={() =>
                            handleReplyCopy(
                              `${process.env.REACT_APP_URL}/detail/${topicId}/${reply.post_number}`,
                              index
                            )
                          }
                        >
                          <img src="/images/post/post-copy.svg" alt="" />
                          {isTopic && (
                            <p className="text-[#666666] text-sm font-medium max-820:hidden">
                              نسخ الرابط
                            </p>
                          )}
                          {replyToolTips[index] && (
                            <div
                              className="absolute top-[-30px] left-[50%] transform -translate-x-1/2 bg-[#004D5A] text-white text-xs px-2 py-1 rounded-md shadow"
                              style={{ whiteSpace: "nowrap" }}
                            >
                              تم نسخ الرابط
                            </div>
                          )}
                        </div>
                        {reply?.yours && isLoggedin && (
                          <div
                            onClick={(e) => {
                              handleDelete(reply?.id, e);
                              dispatch(removeReply(reply?.id));
                            }}
                            className={`relative gap-2 flex items-center border-[1px] border-[#EEEEEE] rounded-sm h-[42px] hover:bg-gray-100 transition-colors ps-3 ${
                              isTopic ? "max-820px:pe-5 pe-3" : "pe-3"
                            }  ${
                              isLoggedin
                                ? "cursor-pointer"
                                : "cursor-not-allowed"
                            }`}
                          >
                            {loading.deletePost[reply.id] ? (
                              <>
                                <img
                                  loading="eager"
                                  src="/images/salla_loader_big.svg"
                                  alt="Loading..."
                                  className="w-[12px] h-[15px] loader"
                                />
                                {isTopic && (
                                  <p className="text-[#666666] text-sm font-medium">
                                    حذف
                                  </p>
                                )}
                                {!isTopic && (
                                  <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                                    حذف
                                  </p>
                                )}
                              </>
                            ) : (
                              <>
                                <img
                                  src="/images/post/post-delete.svg"
                                  alt="delete"
                                />
                                {isTopic && (
                                  <p className="text-[#666666] text-sm font-medium">
                                    حذف
                                  </p>
                                )}
                                {!isTopic && (
                                  <p className="text-[#666666] text-sm font-medium min-1060:hidden">
                                    حذف
                                  </p>
                                )}
                              </>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="flex gap-2 items-center">
                        <img src="/images/post/post-date.svg" alt="" />
                        <p className="text-right text-[#999999] text-xs font-medium whitespace-nowrap">
                          {moment(reply?.created_at).locale("ar").fromNow()}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="w-full sm:ms-8 ms-3">
              <div
                className={`flex gap-2 ${
                  isLoggedin ? "-mb-5" : ""
                } items-center`}
              >
                <div className="sm:w-7 w-4 border-s border-b rounded-br-[5px] h-6"></div>
                <div className="flex gap-2 items-center mt-4">
                  {isLoggedin ? (
                    <>
                      <img
                        className="w-[44px] h-[44px] rounded-full"
                        src={process.env.REACT_APP_API_URL + avatarTemplate}
                        alt="pfp"
                      />
                      <div className="flex items-center gap-2">
                        <img
                          src="/images/post/post-addReply.svg"
                          alt="fowroard"
                        />
                        <p className="text-[#666666] text-sm font-medium">
                          أنت تقوم بالرد على {username}
                        </p>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="flex flex-wrap items-center gap-2">
                        <img
                          src="/images/post/post-addReply.svg"
                          alt="fowroard"
                        />
                        <p className="text-[#666666] text-sm font-medium">
                          الرجاء تسجيل الدخول للرد
                        </p>
                        <a
                          href={
                            process.env.REACT_APP_API_URL + `/auth/oauth2_basic`
                          }
                          className="flex but but--medium bg-[#004D5A] hover:bg-[#003E4A]"
                        >
                          <p className="text-secondary-25 text-medium text-[16px]">
                            تسجيل الدخول
                          </p>
                        </a>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <style>
                {`
                .flex.flex-col.mt-11 .ql-container {
                  height: 140px !important;
                }
              `}
              </style>
              {isLoggedin && (
                <form
                  className="flex flex-col mt-11 sm:mt-6  sm:ms-[90px] ms-7 sm:me-9 me-3"
                  onSubmit={handleFormSubmit}
                >
                  <div className="shadow-md rounded-[10px] bg-white">
                    {errors?.map((error, index) => (
                      <span key={index} className="text-red-500 block">
                        {error}
                      </span>
                    ))}

                    <CustomReactQuill
                      quillRef={quillRef}
                      modules={modules}
                      placeholder="أضف تعليقك على هذا المنشور 🖊️"
                    />
                  </div>

                  <div className="flex space-x-4 pt-4 w-fit self-end">
                    <button
                      disabled={loadingReplies}
                      type="submit"
                      className="bg-[#004D5A] flex gap-2 flex-grow-0 px-9 py-3 rounded-[4px] text-white text-medium text-[16px]"
                    >
                      {replying ? (
                        <img
                          loading="eager"
                          src="/images/salla_loader_big.svg"
                          alt="Loading..."
                          className="w-[12px] h-[15px] loader"
                        />
                      ) : (
                        <img
                          src="/images/post/post-sendReply.svg"
                          alt="reply"
                        />
                      )}
                      {replying ? "الرجاء الانتظار..." : "نشر الرد"}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}
      {formVisible && (
        <div className="fixed inset-0 z-50 flex justify-center items-end bg-opacity-20">
          <div
            ref={modalRef}
            style={{ boxShadow: "0px 10px 100px 12px rgba(0, 0, 0, 0.1)" }}
            className={`relative flex flex-col   ${
              modalMaximized
                ? "w-full h-full"
                : "sm:w-[1220px] h-full sm:h-auto w-full"
            } rounded-lg bg-[#fbfdfe] shadow-lg overflow-hidden`}
            dir="rtl"
          >
            <div className="px-4 md:px-10 pt-8 top-8 flex justify-between">
              <div className="flex gap-5 items-center">
                <img
                  src="/images/modalpen.png"
                  alt=""
                  className="cursor-pointer h-[48px]"
                />
                {isTopic ? (
                  <span className="text-[20px] sm:text-[24px] font-medium sm:font-bold my-0.5">
                    تعديل المنشور
                  </span>
                ) : (
                  <span className="text-[20px] sm:text-[24px] font-medium sm:font-bold my-0.5">
                    تعديل التعليق
                  </span>
                )}
              </div>

              <div className="flex gap-5 sm:gap-10">
                <img
                  src="/images/expand.svg"
                  alt=""
                  className="sm:block hidden cursor-pointer w-[24px] h-[24px]"
                  onClick={() => setModalMaximized((prev) => !prev)}
                />
                <img
                  src="/images/home/cross.svg"
                  alt=""
                  className="cursor-pointer w-[24px] h-[24px]"
                  onClick={() => {
                    setModalMaximized(false);
                    handleClose();
                  }}
                />
              </div>
            </div>
            <hr
              className="mt-5"
              style={{
                height: "1px",
                borderWidth: 0,
                color: "#F1F8F9",
                backgroundColor: "#F1F8F9",
              }}
            />
            <div
              className={`overflow-y-auto pt-5 sm:max-h-[85svh] custom-scrollbar scroll-ms-4 md:px-10 px-4 ${
                modalMaximized ? "h-full" : ""
              } sm:h-auto h-full`}
            >
              <form
                className={`flex md:flex-row flex-col gap-x-11 ${
                  modalMaximized ? "justify-center" : ""
                }`}
                onSubmit={handleSubmitEdit}
              >
                <div className="flex flex-col rounded-lg border-[#EEE] border  w-full shadow-md max-md:mt-6">
                  {errors &&
                    errors?.map((error, index) => (
                      <span key={index} className="text-red-500 block">
                        {error}
                      </span>
                    ))}
                  <div>
                    {isTopic && (
                      <input
                        required={true}
                        type="text"
                        id="title"
                        name="title"
                        value={updatedTitle}
                        onChange={(e) => setUpdatedTitle(e.target.value)}
                        className=" h-[54px] p-2 px-5 w-full border-b-0 rounded-lg rounded-b-none placeholder:text-[#BBBBBB]"
                        placeholder="اكتب عنوان لمنشورك"
                      />
                    )}

                    <CustomReactQuill
                      quillRef={quillRef}
                      modules={modules}
                      placeholder="شارك أفكارك، أسئلتك، أو أيّ موضوع يهم مجتمع سلة."
                    />
                  </div>
                  <div className="flex justify-end gap-4 py-8 px-10">
                    {replying ? (
                      <img
                        loading="eager"
                        src="/images/salla_loader_big.svg"
                        alt="Loading..."
                        className="w-4 h-4 loader"
                      />
                    ) : (
                      <>
                        {isTopic ? (
                          <button
                            type="submit"
                            className="transition-colors btn bg-blue-500 px-6 py-2.5 text-white rounded-[4px]"
                          >
                            تعديل المنشور
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="transition-colors btn bg-blue-500 px-6 py-2.5 text-white rounded-[4px]"
                          >
                            تعديل التعليق
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </form>
              <p className="text-center text-[#999999] text-base font-normal my-20">
                اطّلع على ضوابط المشاركة؛ للمحافظة على نقاشات مُثرية وملهمة تترك
                أثرًا إيجابيًا في مجتمع سلة
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default PostDetailItem;
